var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-primary tc-wd-word-label mr-2 sentence flex items-center justify-center"},[_vm._v(_vm._s(_vm.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }